import DialogShowPackagesRate from "./DialogShowPackagesRate";

export default {
    name     : 'dialog_show_packages_rate',
    component: DialogShowPackagesRate,
    dialog   : {
        'max-width': "1050px",
        'persistent': true
    }
}
